var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9591 0C22.1855 0 24 1.81447 24 4.05067V6.11729V17.8897V19.9493C24 22.1855 22.1855 24 19.9591 24H4.04087C1.81447 24 0 22.1855 0 19.9493V17.8897V6.11729V4.05067C0 1.81447 1.81447 0 4.04087 0H19.9591ZM1.76543 5.55367V17.8878C1.76543 17.8884 1.76543 17.889 1.76543 17.8897V19.9493C1.76543 21.0521 2.54638 21.9747 3.58265 22.1881C3.73069 22.2186 3.88394 22.2346 4.04087 22.2346H19.9591C21.2145 22.2346 22.2346 21.2096 22.2346 19.9493L22.2346 17.8897C22.2346 17.889 22.2346 17.8884 22.2346 17.8878V6.11729V4.05067C22.2346 2.79036 21.2145 1.76543 19.9591 1.76543H4.04087C3.09931 1.76543 2.29015 2.34195 1.94442 3.16191C1.82918 3.43523 1.76543 3.73559 1.76543 4.05067L1.76543 5.55367Z",
    fill: "#A4AAC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4H5ZM5.75 5.25C5.47386 5.25 5.25 5.47386 5.25 5.75V9.25C5.25 9.52614 5.47386 9.75 5.75 9.75H9.25C9.52614 9.75 9.75 9.52614 9.75 9.25V5.75C9.75 5.47386 9.52614 5.25 9.25 5.25H5.75Z",
    fill: "#A4AAC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13C4.44772 13 4 13.4477 4 14V19C4 19.5523 4.44772 20 5 20H10C10.5523 20 11 19.5523 11 19V14C11 13.4477 10.5523 13 10 13H5ZM5.75 14.25C5.47386 14.25 5.25 14.4739 5.25 14.75V18.25C5.25 18.5261 5.47386 18.75 5.75 18.75H9.25C9.52614 18.75 9.75 18.5261 9.75 18.25V14.75C9.75 14.4739 9.52614 14.25 9.25 14.25H5.75Z",
    fill: "#A4AAC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C13.4477 4 13 4.44772 13 5V10C13 10.5523 13.4477 11 14 11H19C19.5523 11 20 10.5523 20 10V5C20 4.44772 19.5523 4 19 4H14ZM14.75 5.25C14.4739 5.25 14.25 5.47386 14.25 5.75V9.25C14.25 9.52614 14.4739 9.75 14.75 9.75H18.25C18.5261 9.75 18.75 9.52614 18.75 9.25V5.75C18.75 5.47386 18.5261 5.25 18.25 5.25H14.75Z",
    fill: "#A4AAC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13C13.4477 13 13 13.4477 13 14V19C13 19.5523 13.4477 20 14 20H19C19.5523 20 20 19.5523 20 19V14C20 13.4477 19.5523 13 19 13H14ZM14.75 14.25C14.4739 14.25 14.25 14.4739 14.25 14.75V18.25C14.25 18.5261 14.4739 18.75 14.75 18.75H18.25C18.5261 18.75 18.75 18.5261 18.75 18.25V14.75C18.75 14.4739 18.5261 14.25 18.25 14.25H14.75Z",
    fill: "#A4AAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedules);
export default __webpack_public_path__ + "static/media/schedules.1a920af1afd8b857879ebcece7abce68.svg";
export { ForwardRef as ReactComponent };